<app-pagetoolbar label="Pairs" icon="group"></app-pagetoolbar>
<mat-accordion multi="false">
  <div class="filter-section">
    <mat-form-field>
      <mat-label>Filter pairs</mat-label>
      <input matInput [formControl]="searchControl" placeholder="Type to filter..." />
      <button *ngIf="searchControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="searchControl.setValue('')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-button-toggle-group [value]="'all'" [hideSingleSelectionIndicator]="true" appearance="legacy">
      <mat-button-toggle value="all" (click)="showAll()">Show All</mat-button-toggle>
      <mat-button-toggle (click)="toggleActiveFilter()">{{ activeLabel$ | async }}</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <mat-expansion-panel
    (opened)="panelOpenState[i] = true"
    (closed)="panelOpenState[i] = false"
    *ngFor="let pair of filteredPairs; let i = index"
    class="pair"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <b class="random-number">Donor <span [innerHTML]="pair.donor.enisNumber | highlight: searchControl.value || ''"></span></b>
        <span class="ellipsis-container participant-name">
          <span [innerHTML]="pair.donor.firstName + ' ' + pair.donor.lastName | highlight: searchControl.value || ''"></span>
        </span>
      </mat-panel-title>
      <mat-panel-description>
        <span style="margin-left: 35%"> {{ pair.relationToRecipient }} </span>
      </mat-panel-description>
      <mat-panel-description class="recipient-title">
        <b class="random-number">Recipient <span [innerHTML]="pair.recipient.enisNumber | highlight: searchControl.value || ''"></span></b>
        <span class="ellipsis-container participant-name">
          <span [innerHTML]="pair.recipient.firstName + ' ' + pair.recipient.lastName | highlight: searchControl.value || ''"></span>
        </span>
      </mat-panel-description>
      <app-warning-chips [pair]="pair" [isPanelOpen]="panelOpenState[i]" (pairUpdated)="onPairUpdated($event)" style="margin-right: 10px"></app-warning-chips>
    </mat-expansion-panel-header>

    <ng-container>
      <div class="inactive-reason" *ngIf="!pair.active">Inactive with reason: {{ pair.reasonInactive }}</div>
      <div class="participant-boxes separator-bottom responsive-layout">
        <app-participant-box [donor]="pair.donor" [pair]="pair" style="width: 50%; border-right: 1px solid #eee"> </app-participant-box>
        <app-participant-box [recipient]="pair.recipient" [pair]="pair" style="width: 50%"> </app-participant-box>
      </div>
      <div>
        <p>
          <label>Participated in</label>
          {{ pair.matchingPeriodCount || 0 }} matching periods
        </p>
        <p>
          <label>Comments</label>
          {{ pair.comments || "-" }}
        </p>
        <a href="/history/pair/{{ pair.id }}">See pair history</a>
      </div>
    </ng-container>

    <mat-action-row>
      <button *ngIf="canRemovePair" mat-button class="warn-button" (click)="removePair(pair)">Archive <br /></button>
      <button *ngIf="canEditPair" mat-button class="custom-button" (click)="editPair(pair)" color="primary">Edit</button>
      <button *ngIf="pair.active && canInactivatePair" mat-button [matMenuTriggerFor]="withdrawMenu" class="custom-button" color="accent">Set inactive</button>
      <mat-menu #withdrawMenu="matMenu">
        <button *ngFor="let reason of getWithdrawReasons() | keyvalue" (click)="withdrawPair(pair, reason)" mat-menu-item>
          {{ reason.value }}
        </button>
      </mat-menu>
      <button *ngIf="!pair.active && canInactivatePair && canActivatePairEntity(pair)" mat-button class="custom-button" (click)="activatePair(pair)" color="accent">Set active</button>
    </mat-action-row>
  </mat-expansion-panel>
</mat-accordion>

<div class="rowcount">showing {{ filteredPairs.length }} of {{ pairs.length }} pairs</div>

<button *ngIf="canAddPair" id="new-pair" (click)="addPair()" mat-fab>
  <mat-icon>group_add</mat-icon>
</button>
